export default import.meta.ROLLDOWN_FILE_URL_5x_TR14GBrd238lRNBwd1A